// extracted by mini-css-extract-plugin
export default {"closed":"ChatWithUsButton-closed_P742V","containerIcon":"ChatWithUsButton-containerIcon_ztdle","icon":"ChatWithUsButton-icon_CbwyV","text":"ChatWithUsButton-text_jWLl4"};